export enum MeetingEventType {
    Mute =	3,
    Unmute =	4,
    ScreenshareStart =	5,
    ScreenshareEnd =	6,
    TurnOnCamera =	7,
    TurnOffCamera =	8,
    ChatError =	9,
    CallError =	10,
    MessageSent =	11,
    Userjoined =	12,
    UserLeft =	13,
    MeetingStarted = 16,
    MeetingEnded = 17
}